import React from "react";
import { Pressable, Text } from "react-native";

import { AI_EXHIBIT_COLORS as C } from "../aiExhibitTheme";

export default function AIExhibitNarrationPressable({
  audioEnabled = false,
  children,
  onPress,
  style,
}) {
  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel="Play narration"
      onPress={onPress}
      style={({ pressed }) => [
        style,
        { position: "relative", opacity: pressed ? 0.9 : 1 },
      ]}
    >
      {audioEnabled ? (
        <Text
          style={{
            position: "absolute",
            top: 10,
            right: 12,
            color: C.accent,
            fontSize: 16,
            zIndex: 2,
          }}
        >
          🔊
        </Text>
      ) : null}
      {children}
    </Pressable>
  );
}
